import { useEffect, useState } from 'react';
import BrowserInteractionTime from 'browser-interaction-time';
export const useBrowserInteractionTime = threshold => {
  const [idle, setIdle] = useState(false);
  useEffect(() => {
    let timer;
    timer = new BrowserInteractionTime({
      idleTimeoutMs: threshold,
      stopTimerOnTabchange: false,
      browserTabActiveCallbacks: [() => {
        setIdle(false);
      }],
      browserTabInactiveCallbacks: [() => {
        setIdle(true);
      }],
      idleCallbacks: [() => {
        if (!idle) {
          setIdle(true);
        }
      }],
      activeCallbacks: [() => {
        if (idle) {
          setIdle(false);
        }
      }]
    });
    timer.startTimer();
    return () => {
      timer = null;
    };
  }, [threshold, idle]);
  return {
    idle
  };
};